import './CSS/navBar.css';

function Navbar() {
  const portfolioname = "TS";
  const period = ".";
  return (
    <nav id="navbarmain" class="navbar navbar-expand-lg navbar-light bg-white ">
       
       <p class="Logo">{portfolioname}</p><p id="period">{period}</p> 
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavAltMarkup" aria-controls="navbarNavAltMarkup" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    
    <div class="collapse navbar-collapse" id="navbarNavAltMarkup">
        
      <div class="navbar-nav ml-auto">
       
        <a class="nav-item nav-link active navbar-style px-4" href="#navbarmain">Home <span class="sr-only">(current)</span></a>
        <a class="nav-item nav-link navbar-style px-4" href="#aboutMeText">About me</a>
        <a class="nav-item nav-link navbar-style px-4" href="#MyProjects">Projects</a>
        <a class="nav-item nav-link navbar-style px-4" href="#LineMadeBy">Contact</a>
      </div>
    </div>
  </nav>
  );
}

export default Navbar;
